import React, { FC } from 'react';

import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { TFunctionResult } from 'i18next';

import { useTextStyles } from '../../../../utils/styles';
import useStyles from './styles';

interface InfoRowProps {
  label: string;
  value: TFunctionResult | string | number;
  isMobile: boolean;
}

const InfoRow: FC<InfoRowProps> = ({ label, value, isMobile }) => {
  const classes = useStyles();
  const textClasses = useTextStyles();

  return (
    <div className={classes.infoRow}>
      <Typography
        variant="h4"
        className={cx(isMobile ? textClasses.metaLabel : textClasses.h4, classes.infoTitle)}
      >
        {label}
      </Typography>
      <Typography
        className={cx(isMobile ? textClasses.meta : textClasses.bodyText, classes.infoText)}
      >
        {value}
      </Typography>
    </div>
  );
};

export default InfoRow;
